#import "../fragments/form-fragment.graphql"

mutation CreateForm($input: FormCreateInput!) {
    formCreate(input: $input) {
        form {
            ...FormFragment
        }
    }
}
